import styled from 'styled-components';

export const StyledSnackbar = styled.div`
  position: fixed;
  top: 77px;
  right: 10px;
  z-index: 9999;
  padding: 15px;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid var(--greyWolf);
  min-width: 320px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
`;
